export default {"src":"/_next/static/media/arrow-white.fbcd9ad0.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};